module.exports = __webpack_public_path__ + "fonts/MabryPro-Regular.6a60d08.woff";